import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import { useScopes } from "../../../../../../STOperationhooks/useScopes";
import { useSelector } from "react-redux";
import { useMemo } from "react";

interface BulkActionModalProps {
  open: boolean;
  onClose: () => void;
}

const MoveAnotherCampaign = ({ open, onClose }: BulkActionModalProps) => {
  const { removeNegativeSearchTerm } = useScopes();
  const {
    selectedRowsForNegativesCampaign,
    singleRowIDPassToModalForCampaign,
    // removeNegativeLoadingCampaignLoading,
  } = useSelector((state: any) => state.searchTermOperation);
  const records = useMemo(() => {
    if (!selectedRowsForNegativesCampaign) return [];
    return singleRowIDPassToModalForCampaign
      ? selectedRowsForNegativesCampaign.filter(
          (row: any) => row.id === singleRowIDPassToModalForCampaign
        )
      : selectedRowsForNegativesCampaign;
  }, [selectedRowsForNegativesCampaign, singleRowIDPassToModalForCampaign]);

  // 🔹 Grouped data according to campaign_id and total count(search term)
  const { groupedDataByCampaign, totalRemovedCount } = useMemo(() => {
    const grouped = Object.values(
      (records || []).reduce((acc: any, row: any) => {
        if (!acc[row.campaign_id]) {
          acc[row.campaign_id] = {
            campaign_id: row.campaign_id,
            campaign_name: row.campaign_name, // keep the name
            removedCount: 0,
            search_terms: [],
          };
        }

        acc[row.campaign_id].removedCount += 1;
        acc[row.campaign_id].search_terms.push(row.search_term);
        return acc;
      }, {} as Record<string, any>)
    );

    if (grouped.length === 0) {
      // handle empty case here
      return {
        groupedDataByCampaign: [],
        totalRemovedCount: 0,
        totalCampaign: 0,
      };
    }

    const total = grouped.reduce(
      (sum: number, group: any) => sum + group.removedCount,
      0
    ); // total removed count(Search Terms)
    const totalCampaign = grouped.length; // total campaign

    return {
      groupedDataByCampaign: grouped,
      totalRemovedCount: total,
      totalCampaign: totalCampaign,
    };
  }, [records]);

  // close modal and clear selected rows and single row id
  const handleCloseNegativeModalThird = () => {
    onClose();
  };

  // remove negative terms from capaigns and added to adgroups
  const removedNegativeTermsFromCampaignAndMoveAdGroup = async () => {
    const sharedUids = records?.map((item: any) => item.shared_uid) || [];
    if (sharedUids.length === 0) return;
    const reqBody = {
      terms: sharedUids.map((uid: string) => ({
        shared_uid: uid,
        keep_in_ad_groups: true,
      })),
    };

    removeNegativeSearchTerm(
      reqBody,
      handleCloseNegativeModalThird,
      "campaigns"
    );
  };
  return (
    <Dialog
      open={open}
      onClose={handleCloseNegativeModalThird}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        Total Number of Search Terms Moved to other campaign Campaign:{" "}
        {totalRemovedCount}
      </DialogTitle>
      <DialogContent sx={{ padding: "0px 20px 16px" }}>
        <Typography>Moved to other campaign</Typography>
        <TableContainer component={Paper} elevation={0}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel>Campaign Name</TableSortLabel>
                </TableCell>
                <TableCell align="left">
                  <TableSortLabel>
                    {totalRemovedCount} of Search Terms Removed from Campaign
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {groupedDataByCampaign.map((row: any, index: any) => (
                <TableRow key={index}>
                  <TableCell>{row.campaign_name}</TableCell>
                  <TableCell align="left">{row.removedCount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 16px 20px 16px" }}>
        <Button
          onClick={handleCloseNegativeModalThird}
          color="secondary"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          data-tracker="511"
          color="secondary"
          onClick={removedNegativeTermsFromCampaignAndMoveAdGroup}
          variant="contained"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveAnotherCampaign;
